import type { GetInteractionAggregatesReqFiltersV2Item } from '@/api/generated/model';
import { QUERY_KEY_FETCH_ANALYTICS_CHART_DATA, QUERY_KEY_INTERACTION_AGGREGATES } from '@/constants/query-keys';
import type { SegmentKind } from '@/domains/pages/ai-proficiency/utils/segment-api-payloads';

export {
  NEBULY_PAGE_QUERY_OPTIONS as AI_PROFICIENCY_PAGE_QUERY_OPTIONS,
  getPageTimeRangeQueryKey as getAiProficiencyTimeRangeQueryKey,
} from '@/domains/pages/shared/page-query-options';

export function aiProficiencyOrgScoreQueryKey(projectId: string, timeRangeQueryKey: unknown) {
  return [QUERY_KEY_INTERACTION_AGGREGATES, 'ai-proficiency-score', projectId, timeRangeQueryKey] as const;
}

export function aiProficiencyLadderProficiencyQueryKey(projectId: string, timeRangeQueryKey: unknown) {
  return [
    QUERY_KEY_INTERACTION_AGGREGATES,
    'ai-proficiency-ladder-proficiency',
    projectId,
    timeRangeQueryKey,
  ] as const;
}

export function aiProficiencyOrgScoreTrendQueryKey(projectId: string, chartTrendQueryKey: unknown) {
  return [
    QUERY_KEY_FETCH_ANALYTICS_CHART_DATA,
    'ai-proficiency-org-score-trend',
    projectId,
    chartTrendQueryKey,
  ] as const;
}

export function aiProficiencySegmentsQueryKey(
  segmentKind: SegmentKind,
  projectId: string,
  timeRangeQueryKey: unknown,
) {
  return [
    QUERY_KEY_INTERACTION_AGGREGATES,
    'ai-proficiency-segments',
    segmentKind,
    projectId,
    timeRangeQueryKey,
  ] as const;
}

export function aiProficiencyMethodologyDimensionsQueryKey(
  queryKeySuffix: string,
  projectId: string,
  timeRangeQueryKey: unknown,
  scopeFilters: GetInteractionAggregatesReqFiltersV2Item[],
) {
  return [
    QUERY_KEY_INTERACTION_AGGREGATES,
    'ai-proficiency-methodology-dimensions',
    queryKeySuffix,
    projectId,
    timeRangeQueryKey,
    scopeFilters,
  ] as const;
}

export function upskillingLevelLadderMethodologyQueryKey(
  view: string,
  resolvedSelectedName: string,
  projectId: string,
  timeRangeQueryKey: unknown,
) {
  return [
    QUERY_KEY_INTERACTION_AGGREGATES,
    'upskilling-level-ladder-methodology',
    view,
    resolvedSelectedName,
    projectId,
    timeRangeQueryKey,
  ] as const;
}
